<script>
  export let user = null;
  export let isAdmin = false;
  export let isCompany = false;
  export let isMenuOpen = false;
  export let currentPage = 'home';
  export let onPageChange = () => {};
  export let onLogout = () => {};
  export let onToggleMenu = () => {};

  // 페이지 변경 후 메뉴 닫기 함수
  function handlePageChangeAndClose(page) {
    onPageChange(page);
    onToggleMenu(); // 메뉴 닫기
  }

  // 로그아웃 후 메뉴 닫기 함수
  function handleLogoutAndClose() {
    onLogout();
    onToggleMenu(); // 메뉴 닫기
  }
</script>

<div class="mobile-menu" class:open={isMenuOpen}>
  <button class="close-btn" on:click={onToggleMenu}>✕</button>
  <ul>
    {#if user}
      <li class="user-info">{isAdmin ? '[관리자] ' : isCompany ? '[기업] ' : ''}{user.name || user.email.split('@')[0]}님</li>
      <li><a href="/mypage" on:click|preventDefault={() => handlePageChangeAndClose('mypage')}>마이페이지</a></li>

      <!-- 공통 메뉴: 데스크톱과 동일한 우선순위 -->
      <li><a href="#projects" class:active={currentPage === 'home'} on:click|preventDefault={() => handlePageChangeAndClose('home')}>프로젝트 찾기</a></li>
      <li><a href="/how-to-use" class:active={currentPage === 'how-to-use'} on:click|preventDefault={() => handlePageChangeAndClose('how-to-use')}>이용방법</a></li>

      {#if isAdmin}
        <li><a href="/admin-dashboard" on:click|preventDefault={() => handlePageChangeAndClose('admin-dashboard')}>대시보드</a></li>
        <li><a href="/admin-users" on:click|preventDefault={() => handlePageChangeAndClose('admin-users')}>회원 관리</a></li>
        <li><a href="/admin-applicants" on:click|preventDefault={() => handlePageChangeAndClose('admin-applicants')}>지원자 관리</a></li>
        <li><a href="/project-register" on:click|preventDefault={() => handlePageChangeAndClose('project-register')}>공고 등록</a></li>
      {/if}
      {#if isCompany && !isAdmin}
        <li><a href="/company-applicants" on:click|preventDefault={() => handlePageChangeAndClose('company-applicants')}>지원자 관리</a></li>
        <li><a href="/project-register" on:click|preventDefault={() => handlePageChangeAndClose('project-register')}>공고 등록</a></li>
      {/if}

      <li><a href="/logout" on:click|preventDefault={handleLogoutAndClose}>로그아웃</a></li>
    {:else}
      <!-- 비로그인 시 메뉴 순서 -->
      <li><a href="#projects" class:active={currentPage === 'home'} on:click|preventDefault={() => handlePageChangeAndClose('home')}>프로젝트 찾기</a></li>
      <li><a href="/how-to-use" class:active={currentPage === 'how-to-use'} on:click|preventDefault={() => handlePageChangeAndClose('how-to-use')}>이용방법</a></li>
      <li><a href="/login" on:click|preventDefault={() => handlePageChangeAndClose('login')}>로그인/회원가입</a></li>
    {/if}
  </ul>
</div>

<style>
  .mobile-menu {
    display: none;
    position: fixed;
    top: 0;
    right: -300px;
    width: 300px;
    height: 100vh;
    background-color: white;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
    transition: right 0.3s ease-in-out;
    z-index: 1000;
    padding: 20px;
  }

  .mobile-menu.open {
    right: 0;
  }

  .close-btn {
    background: none;
    border: none;
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 1.5rem;
    cursor: pointer;
  }

  .mobile-menu ul {
    list-style: none;
    margin-top: 60px;
  }

  .mobile-menu li {
    margin-bottom: 20px;
  }

  .mobile-menu a {
    color: #333;
    text-decoration: none;
    font-size: 1.1rem;
    font-weight: 500;
  }

  .mobile-menu a:hover,
  .mobile-menu a.active {
    color: #3273dc;
  }

  .user-info {
    font-weight: bold;
    color: #3273dc;
    padding: 0 0 10px 0;
    border-bottom: 1px solid #eee;
    margin-bottom: 15px;
  }


  @media (max-width: 768px) {
    .mobile-menu {
      display: block;
    }
  }
</style>